
//decoradores
import { Component, VModel, Vue } from "vue-property-decorator";

@Component
export default class TabsTransporte extends Vue {
  @VModel() tab!: number;
}
